<template>
    <table class="w-100 price-table">
        <tbody>
            <tr></tr>
            <tr class="price-info" v-for="price in store.singlePrices">
                <td v-if="price.isTranslation"><span class="float-left realbold">{{$t('Telli tolge')}}</span></td>
                <td v-else><span class="float-left realbold">{{price.name[$i18n.locale]}}</span></td>
                <td><span class="float-right">1 x {{getPriceWithVAT(price.single_price).toFixed(2)}} €</span></td>
            </tr>
            <tr v-if="store.singlePrices && store.singlePrices.length > 0">
                <td></td>
                <td>
                    <div class="float-right">
                        <span class="realbold">{{$t("Kokku")}}: </span>
                        <span class="total-price realbold"> {{totalSinglePrice}} €</span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
import { useMainStore } from '../includes/store';
import { computed } from 'vue';
import { useTax } from '../composables/useTax.js';

const store = useMainStore();
const { getPriceWithVAT } = useTax();

const totalSinglePrice = computed(() => {
    let total = 0;
    store.singlePrices.forEach(price => {
        total += parseFloat(price.single_price);
    });
    return getPriceWithVAT(total).toFixed(2);
})
</script>
